/* global document, window, Promise */

const SITE_KEY_ATTRIBUTE = 'data-recaptcha-sitekey';
const ACTION_ATTRIBUTE = 'data-recaptcha-action';
const READY_FLAG = 'recaptchaReady';

const tokenInput = document.querySelector(`[${SITE_KEY_ATTRIBUTE}]`);
const siteKey = tokenInput !== null ? tokenInput.getAttribute(SITE_KEY_ATTRIBUTE) : '';


// Resolves on 'error' as well, so that a blocked or unreachable api.js
// does not keep the form from being submitted.
function loadApiScript() {
	return new Promise((resolve) => {
		const script = document.createElement('script');
		script.async = true;
		script.defer = true;
		script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
		script.addEventListener('load', resolve);
		script.addEventListener('error', resolve);
		window.document.body.appendChild(script);
	});
}


function requestToken(apiScriptLoaded) {
	return apiScriptLoaded.then(() => new Promise((resolve) => {
		const { grecaptcha } = window;

		if (grecaptcha === undefined) {
			resolve();
			return;
		}

		grecaptcha.ready(() => {
			grecaptcha
				.execute(siteKey, { action: tokenInput.getAttribute(ACTION_ATTRIBUTE) })
				.then((token) => {
					tokenInput.value = token;
					resolve();
				})
				// On any reCAPTCHA failure the form is sent with an empty token
				// and the server side decides what to do with it.
				.catch(resolve);
		});
	}));
}


// reCAPTCHA tokens are valid for two minutes only, so the token is requested on submit
// instead of on page load - filling in the registration form takes a while.
function handleSubmit(event, apiScriptLoaded) {
	const form = event.target;

	if (event.defaultPrevented || form.dataset[READY_FLAG] === '1') {
		return;
	}

	event.preventDefault();

	requestToken(apiScriptLoaded).then(() => {
		const submitButton = form.querySelector('input[type="submit"]');
		form.dataset[READY_FLAG] = '1';

		// Clicking the button instead of calling form.submit() keeps both
		// the netteForms validation and the name of the submit button in the request.
		if (submitButton !== null) {
			submitButton.click();
		} else {
			form.submit();
		}
	});
}


if (tokenInput !== null && siteKey !== '' && tokenInput.form !== null) {
	const apiScriptLoaded = loadApiScript();
	tokenInput.form.addEventListener('submit', event => handleSubmit(event, apiScriptLoaded));
}



// WEBPACK FOOTER //
// ./frontend/js/recaptcha.js